import {
  FETCH_ACTIVITY_LOGS_REQUEST,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_ACTIVITY_LOGS_FAILURE,
} from '../../types/activityLog/activityLogTypes';

const initialState = {
  loading: false,
  logs: [],
  error: null,
};

const activityLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LOGS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ACTIVITY_LOGS_SUCCESS:
      return { ...state, loading: false, logs: action.payload, error: null };
    case FETCH_ACTIVITY_LOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default activityLogReducer; 